import { Switch, Typography } from "@material-ui/core";
import * as React from "react";
import { useEffect, useState } from "react";
import { Animated } from "react-animated-css";
import {
  Accordion,
  AccordionCollapse,
  AccordionToggle,
  Button,
  Dropdown,
  DropdownButton
} from "react-bootstrap";
import CheckPermission from "../../General/CheckPermission";
import RBAC, { ModulesName, UserActions } from "../../General/roleModuleActions";
import { showDecisionAlert, showWarningAlert } from "../../../index";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader
} from "../../../_metronic/_partials/controls/Card";
import * as Api from "../../General/api";
import * as Common from "../../General/common";
import ResidentAsssessmentWounds from "../resident/residentAsssessmentWounds";
import PopupModal from "../modal/popupmodal";
import Newresident from "../modal/residentsmodals/newresident";
import Insurance from "../resident/insurance";
import ResidentDetails from "../resident/residentdetails";
import ResidentStatus from "../resident/residentStatus";
import ICDReport from "../modal/reports/icdreport";
import AOB from "../resident/aob";
import PatientOrders from "../resident/patientorders";
import ResidentNotes from "../resident/residentnotes";
import WoundLocation from "../resident/woundlocation";
import WoundNote from "../resident/woundnote";
import moment from "moment";
import SelectableContext from "react-bootstrap/SelectableContext";
import FindResident from "../resident/findResident";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FacilityResidentHistory from "../resident/residentHistory";
import { useSelector } from "react-redux";
import ViewWoundInformationChangeReason from "../resident/viewWoundInformationChangeReason";
import NewWoundAssessment from "../resident/newwoundassessment";
import { WOUND_TYPES } from "../../General/wound-type";

var _sampleWoundObj = {
  fkResidentId: 0,
  residentName: "",
  facilityName: "",
  roomUnit: "",
  // evaluatedBy: Common.replaceNullWithString(user.firstName) + " " + Common.replaceNullWithString(user.lastName),
  physicanName: "",
  btPatientBrightreeID: null,
  fkLastWoundDetailId: null,
  isWoundInfoChange: false,
  changeReason: "",
  fkSalesOrderId: 0,
  wound: {
    id: 0,
    woundDetailId: 0,
    // evaluationDate: '',
    // dateFirstObserved: '',
    // fkAcquisitionId: null,
    fkWoundLocationId: null,
    woundLocation: "",
    fkWoundTypeId: null,
    woundDescription: "",
    fkWoundThicknessId: null,
    //fkWoundSevereTissueTypeId: null,
    fkWoundLateralityId: null,
    woundLength: "",
    woundWidth: "",
    woundDepth: "",
    isUtd: false,
    tunneling: false,
    tunnelingDepth: null,
    tunnelingClockPosition: "",
    undermining: false,
    underminingDepth: null,
    underminingClockPosition: null,
    icdcode: "",
    fkExudateAmountId: null,
    fkExudateTypeId: null,
    exudateColor: "",
    fkDebridementTypeId: null,
    debridementDate: null,
    surgicalDate: null,
    odor: false,
    Pain: false,
    painMedicationOrdered: false,
    sloughPercentage: null,
    necroticPercentage: null,
    //FkWoundCleanseId :'',
    cleanseDescription: null,
    fkDressingChangeFrequencyId: 8,
    //fkPrimaryDressingId :null,
    //FkAdditionalPrimaryDressingId :'',
    otherAdditionalPrimaryDressing: "",
    //fkSecondaryDressingId :null,
    //FkAdditionalSecondaryDressingId :'',
    otherAdditionalSecondaryDressing: "",
    treatment: "",
    comments: "",
    thicknessIdForBackStagging: null,
    orientationLeftRight: null,
    orientationUpperLower: null,
    orientationInnerOuter: null,
    orientationAnteriorPosterior: null,
    orientationMedialLateral: null,
    orientationDorsalDistalProximal: null,
    orientationMidline: null,
    isDocumentation: false,
    isPartailOrder: false
    // FkWoundcareProductTypeId :'',
  }
};

var UpsertNewresident,
  insuranceModal,
  residentHistoryModal,
  woundAmendModal,
  residentStatusModal,
  addStatusRef,
  residentInfoModal,
  AddResidentModal,
  patientOrdersModal,
  ResidentNotesModal,
  woundAssessmentModel,
  AOBModal,
  WoundNoteModal = null;

export function AllFacilityResident(props) {
  //#region Resident modal
  const [showModalResident, setShowResident] = useState(false);
  const [isResidentInfoEdit, setisResidentInfoEdit] = useState(false);
  const [residentListState, setResidentListState] = useState([]);
  const [residentListUI, setResidentListUI] = useState([]);
  const [Resident, setResident] = useState("");
  const [ResidentID, setResidentID] = useState("");
  const [ResidentName, setResidentName] = useState("");
  const FacilityId = props.facility.id;
  const [facilityName, setFacilityName] = useState("");
  const [chain, setChainName] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const { user } = useSelector((state) => state.auth);
  const [showAddWoundComponent, setAddWoundComponent] = useState(null);
  const handleCloseResident = () => setShowResident(false);
  const handleShowResident = () => setShowResident(true);
  //#endregion
  const [residentLoading, setResidentLoading] = useState(false);
  const displatWarningAlert = () =>
    showWarningAlert("Coming soon!!!", "Alert");
  const displayDecisionAlert = (title, message) =>
    showDecisionAlert(
      function () {},
      function () {},
      title == null ? "Are you sure?" : title,
      message == null
        ? "You want to deactivate this Resident."
        : message
    );

  const [isLoading, setIsLoading] = useState(false);

  // NEW: single controlled accordion (all closed by default)
  const [activeAccordionKey, setActiveAccordionKey] = useState(null);

  useEffect(() => {
    getAllResident();
  }, []);

  //#region Set Resident List
  const getAllResident = () => {
    setIsLoading(true);
    if (props.isPartail) {
      Api.getRequestQry(
        Api.URI_GetAllBillingQueueResidentByFacilityID,
        "?facilityID=" +
          FacilityId +
          "&isPartailOrder=" +
          1 +
          "&partailOrderDate=" +
          props.facility.cycleDate +
          "&processStatusId=" +
          props.facility.fkProcessStatusId
      )
        .then((res) => {
          if (res.data.statusCode == 200) {
            if (res.data.result != null && res.data.result.length > 0) {
              setResidentList(res.data.result);
            }
          }
        })
        .catch(() => {})
        .then(() => {
          setIsLoading(false);
          Common.LoadDataTable("residentsList");
        });
    } else if (props.assessmentQueue) {
        Api.getRequestQry(
            Api.URI_GetAllResidentByFacilityID,
            "?facilityID=" + FacilityId + "&residentStatusId=" + 36 + "&isAssessmentQueue=" + 1
        )
            .then((res) => {
                if (res.data.statusCode == 200) {
                    if (res.data.result != null && res.data.result.length > 0) {
                        setResidentList(res.data.result);
                    }
                }
            })
            .catch(() => { })
            .then(() => {
                setIsLoading(false);
                Common.LoadDataTable("residentsList");
            });
    } else {
      Api.getRequestQry(
        Api.URI_GetAllResidentByFacilityID,
        "?facilityID=" + FacilityId + "&residentStatusId=" + 36
      )
        .then((res) => {
          if (res.data.statusCode == 200) {
            if (res.data.result != null && res.data.result.length > 0) {
              setResidentList(res.data.result);
            }
          }
        })
        .catch(() => {})
        .then(() => {
          setIsLoading(false);
          Common.LoadDataTable("residentsList");
        });
    }
    };

    const fixImageUrl = (newURL, fileName) => {

        var res = Resident;
        res.imageUrl = newURL;
        res.faceSheetName = fileName;
        setResident(res);

    }

  const handleShowAddResident = (obj) => {
    setResident(obj);
    AddResidentModal.showModal();
  };

  const handleResidentStatus = async (resident) => {
    setResident(resident);
    residentStatusModal.showModal();
  };

  const handleResidentHistory = async (residentId) => {
    setResidentID(residentId);
    residentHistoryModal.showModal();
  };

  const handleNewWound = (newWoundDetail) => {
    setResident(newWoundDetail);
    Common.showConfirmation(
      "Would you like to enter a wound.",
      "",
      handleNewWoundDocumentModal,
      null,
      newWoundDetail,
      "Yes",
      false,
      null,
      "No"
    );
  };

  const handleNewWoundDocumentModal = async (obj) => {
    let tempObj = JSON.parse(JSON.stringify(_sampleWoundObj));

    tempObj.wound.isDocumentation = true;
    tempObj.wound.evaluationDate = new Date();
    tempObj.fkResidentId = obj.id;
    tempObj.residentName =
      Common.replaceNullWithString(obj.firstName) +
      " " +
      Common.replaceNullWithString(obj.lastName);
    tempObj.facilityName = Common.replaceNullWithString(
      props.facility.facilityName
    );
    tempObj.roomUnit =
      Common.replaceNullWithString(obj.room) +
      "/" +
      Common.replaceNullWithString(obj.unit);
    tempObj.physicanName = Common.replaceNullWithString(
      obj.primaryPhysicianName
    );
    tempObj.btPatientBrightreeID = obj.btPatientBrightreeID;

    await setAddWoundComponent(
      <NewWoundAssessment
        isEdit={false}
        canView={true}
        user={user}
        isReorder={false}
        resident={tempObj}
        close={handleCloseWoundAssessmentmodalPopup}
      />
    );
    woundAssessmentModel.showModal();
  };

  const handleCloseWoundAssessmentmodalPopup = () => {
    try {
      woundAssessmentModel.hideModal();
    } catch (error) {
      Common.LogError(error, "WorkqueueWounds", "handleNewWoundAsessmentModal");
    }
  };

  const setResidentList = (list, isShowProduct) => {
    const rows = list.map((item, i) => {
      let obj = JSON.parse(JSON.stringify(item));
      const name = obj.lastName + ", " + obj.firstName;
      const residentID = obj.id;
      const dob =
        obj.doB != null ? moment(obj.doB).format("MM/DD/YYYY") : "N/A";

      let insurance = "No insurance on file";
      if (obj.residentInsuranceList != null) {
        insurance = "";
        for (let d = 0; d < obj.residentInsuranceList.length; d++) {
          let objIns = JSON.parse(
            JSON.stringify(obj.residentInsuranceList[d])
          );
          insurance =
            insurance +
            (insurance != "" ? ", " : "") +
            " " +
            (objIns.isAddEdit ? "*" : "") +
            "=> " +
            objIns.insuranceName;
        }
      }

      const eventKey = obj.id.toString();
      const statusBadgeType =
        obj.isProcess === true ? "badge-success" : "badge-warning";

      return (
        <Card key={obj.id}>
          <CardHeader>
            <AccordionToggle
              as="div"
              eventKey={eventKey}
              className="w-100"
              style={{ cursor: "pointer" }}
            >
              <div
                className={`w-100 d-flex border-bottom m-0 ${
                  obj.isProcess
                    ? "bg-light-success border-success"
                    : "border-light-dark"
                }`}
              >
                <div
                  className="customStyleAccorion"
                  style={{ display: "grid" }}
                >
                  <div
                    title={
                      obj.fkPrimaryPhysicianId == null
                        ? "Primary physician is not assigned"
                        : ""
                    }
                    className={`h5 mb-0 text-dark ${
                      obj.fkPrimaryPhysicianId == null
                        ? "bg-light-danger border-danger"
                        : ""
                    }`}
                  >
                    {name}
                  </div>

                  {obj.fkPrimaryPhysicianId == null && (
                    <small>
                      Primary physician is not assigned
                      <br />
                    </small>
                  )}
                  <small>{insurance}</small>
                </div>

                {user.roles.roleList.find(
                  (x) =>
                    x.roleName ==
                    RBAC.Role_Gentell_IntakeProcessor
                ) == undefined && (
                  <span className={`badge my-auto mx-4 ml-auto`}>
                    <span
                      onClick={(e) => e.stopPropagation()} // don't toggle accordion when clicking dropdown
                    >
                      <SelectableContext.Provider value={false}>
                        <DropdownButton
                          className="d-inline"
                          drop={"down"}
                          size="xs"
                          variant="primary"
                          title={"Actions"}
                          id={`dropdown-button-drop-actions-${obj.id}`}
                          key={"down"}
                        >
                          <Dropdown.Item
                            eventKey="1"
                            onClick={() => {
                              setResident(obj);
                              setisResidentInfoEdit(false);
                              setResidentID(obj.id);
                              residentInfoModal.showModal();
                            }}
                          >
                            Resident Info
                          </Dropdown.Item>
                          <CheckPermission
                            permission={UserActions.Update}
                            module={ModulesName.Module_Residents}
                            yes={() => (
                              <Dropdown.Item
                                eventKey="8"
                                onClick={() => handleResidentStatus(obj)}
                              >
                                Set Resident Status 
                              </Dropdown.Item>
                            )}
                            no={() => null}
                          />
                          <Dropdown.Item
                            eventKey="81"
                            onClick={() => handleResidentHistory(obj.id)}
                          >
                            View History
                          </Dropdown.Item>
                          <Dropdown.Item
                            eventKey="82"
                            onClick={() => woundAmendModal.showModal()}
                          >
                            View Wound Amend History
                          </Dropdown.Item>
                          <Dropdown.Item
                            eventKey="9"
                            onClick={() => {
                              setResidentID(obj.id);
                              setResidentName(name);
                              setFacilityName(props.facility.facilityName);
                              setChainName(props.facility.chain);
                              setOrganizationName(
                                props.facility.organizationName
                              );
                              ResidentNotesModal.showModal();
                            }}
                          >
                            Resident Notes
                          </Dropdown.Item>
                        </DropdownButton>
                      </SelectableContext.Provider>
                    </span>
                  </span>
                )}
              </div>
            </AccordionToggle>
          </CardHeader>

          <AccordionCollapse
            eventKey={eventKey}
            mountOnEnter
            unmountOnExit
          >
            <CardBody>
              <fieldset>
                <ResidentAsssessmentWounds
                  isPartail={props.isPartail}
                  facility={props.facility}
                  isProcessor={
                    user.roles.roleList.find(
                      (x) =>
                        x.roleName ==
                        RBAC.Role_Gentell_IntakeProcessor
                    ) == undefined
                      ? false
                      : true
                  }
                  refresh={() => {
                    getAllResident();
                  }}
                  Resident={obj}
                />
              </fieldset>
            </CardBody>
          </AccordionCollapse>
        </Card>
      );
    });

    setResidentListUI(rows);
  };

  const [ShowAdvancedSearch, showAdvanceSearchSectionState] =
    useState(false);
  const showAdvanceSearchSection = () => {
    showAdvanceSearchSectionState(!ShowAdvancedSearch);
  };

  const toolbar = (
    <div className="card-toolbar">
      <div className="example-tools">
        {user.roles.roleList.find(
          (x) => x.roleName == RBAC.Role_Gentell_IntakeProcessor
        ) == undefined && (
          <CheckPermission
            permission={UserActions.Create}
            module={ModulesName.Module_Residents}
            yes={() => (
              <Button
                variant="primary"
                size="sm"
                className="mr-5"
                onClick={() => {
                  handleShowAddResident(null);
                }}
              >
                New Resident
              </Button>
            )}
            no={() => (
              <Button
                variant="primary"
                size="sm"
                className="mr-5"
                disabled={true}
              >
                New Resident
              </Button>
            )}
          />
        )}
        <CheckPermission
          permission={UserActions.View}
          module={ModulesName.Module_Residents}
          yes={() => (
            <Button
              className="mr-2"
              variant="warning"
              size="sm"
              onClick={showAdvanceSearchSection}
            >
              Resident
            </Button>
          )}
          no={() => null}
        />
        <button
          type="button"
          className="mr-5 btn btn-dark btn-sm"
          onClick={() => props.backPress()}
        >
          Back To Facility List
        </button>
      </div>
    </div>
  );

  return (
    <>
      {ShowAdvancedSearch && (
        <Animated
          animationIn="fadeInLeft"
          animationInDuration={800}
          animationOut="fadeOut"
          isVisible={ShowAdvancedSearch}
        >
          <FindResident
            createWoundType={WOUND_TYPES.ASSESSMENT}
            user={user}
            facility={props.facility}
            refresh={() => {
              getAllResident();
            }}
            facilityId={FacilityId}
            closeSearch={() => {
              showAdvanceSearchSection();
            }}
          />
        </Animated>
      )}
      <Card className="example example-compact">
        <CardHeader>
          <div className="card-title">
            <span>
              <b className="text-success">
                Facility: {props.facility.facilityName}
              </b>{" "}
              ,{" "}
              <br />
              <b>Ownership/Headquarters:</b>{" "}
              {props.facility.organizationName == ""
                ? "N/A"
                : props.facility.organizationName}
              ,{" "}
              <b>Purchasing Group-Chain:</b>{" "}
              {props.facility.chain == ""
                ? "N/A"
                : props.facility.chain}
              ,{" "}
              <b>
                <FormControlLabel
                  label={
                    <Typography>
                      <h4 className="mt-4"> Part B:</h4>
                    </Typography>
                  }
                  labelPlacement="start"
                  control={
                    <Checkbox
                      checked={props.facility.medicarePartBbyGentell}
                      value="checkedA"
                    />
                  }
                />
                <FormControlLabel
                  label={
                    <Typography>
                      <h4 className="mt-4"> Equal Care:</h4>
                    </Typography>
                  }
                  labelPlacement="start"
                  control={
                    <Checkbox
                      checked={props.facility.isEcp}
                      value="checkedB"
                    />
                  }
                />
                <FormControlLabel
                  label={
                    <Typography>
                      <h4 className="mt-4">Outs:</h4>
                    </Typography>
                  }
                  labelPlacement="start"
                  control={
                    <Checkbox
                      checked={props.facility.outProgram}
                      value="checkedC"
                    />
                  }
                />
              </b>
              <h3 className="card-label mt-3">Resident List</h3>
            </span>
          </div>
          {toolbar}
        </CardHeader>
        <CardBody>
          {isLoading ? (
            <div className="row d-flex justify-content-center">
              <span className="mt-5 spinner spinner-primary"></span>
            </div>
          ) : (
            <Accordion
              activeKey={activeAccordionKey ?? undefined}
              onSelect={(key) =>
                setActiveAccordionKey((prev) =>
                  prev === key ? null : key
                )
              }
            >
              {residentListUI}
            </Accordion>
          )}
        </CardBody>
      </Card>

      <PopupModal
        title="Insurances"
        showButton={false}
        ref={(ref) => {
          insuranceModal = ref;
        }}
      >
        <Insurance residentID={ResidentID} />
      </PopupModal>

      <PopupModal
        title="Resident Info"
        showButton={false}
        dialogClassName="modal-90w"
        ref={(ref) => {
          residentInfoModal = ref;
        }}
      >
        {isResidentInfoEdit && (
          <Animated
            animationIn="fadeIn"
            animationInDuration={800}
            animationOut="fadeOut"
            onClose={(ref) => {
              Common.showConfirmation(
                "Are you sure you want to close without saving the data?",
                "Warning",
                () => {
                  ref.setState({ show: false });
                },
                () => {},
                null,
                "Exit Without Saving"
              );
            }}
          >
            <div className="row d-flex align-items-center justify-content-end">
              <Button
                className="mb-4 mr-4 "
                onClick={() => {
                  setisResidentInfoEdit(!isResidentInfoEdit);
                }}
              >
                Go Back To Detail
              </Button>
            </div>
            <Newresident
              ref={(ref) => {
                UpsertNewresident = ref;
              }}
              FacilityId={FacilityId}
              Resident={Resident}
              facility={props.facility}
              setResidentLoading={setResidentLoading}
              close={() => {
                getAllResident(false);
                residentInfoModal.hideModal(true);
              }}
            />
            <div className="row d-flex align-items-center justify-content-end">
              <Button
                className="mb-4 btn-success ml-2"
                disabled={residentLoading}
                onClick={() => {
                  UpsertNewresident.handleSubmit();
                }}
              >
                <span
                  style={{ display: "flex", alignItems: "center" }}
                >
                  {residentLoading && (
                    <span className="mr-8 spinner spinner-white"></span>
                  )}
                  <span>{"Save Changes"}</span>
                </span>
              </Button>
            </div>
          </Animated>
        )}

        {!isResidentInfoEdit && (
          <Animated
            animationIn="fadeIn"
            animationInDuration={800}
            animationOut="fadeOut"
          >
            <div className="row d-flex align-items-center justify-content-end">
              <CheckPermission
                permission={UserActions.Update}
                module={ModulesName.Module_Residents}
                yes={() => (
                  <Button
                    className="mb-4 mr-4"
                    onClick={() => {
                      setisResidentInfoEdit(!isResidentInfoEdit);
                    }}
                  >
                    Edit
                  </Button>
                )}
                no={() => null}
              />
            </div>
            <ResidentDetails
              resident={Resident}
              getAllResident={() => {
                getAllResident(false);
                          }}
              fixImageUrl={fixImageUrl}
            />
          </Animated>
        )}
      </PopupModal>

      {/** Patient Orders Modal */}
      <PopupModal
        title="Resident Orders"
        dialogClassName="modal-90w"
        showButton={false}
        ref={(ref) => {
          patientOrdersModal = ref;
        }}
      >
        <PatientOrders />
      </PopupModal>

      <PopupModal
        title={
          <div className="card-title">
            <span>
              <h3 className="card-label">Wound Amend Messages</h3>
              <small className="">
                <b>Facility:</b> {props.facility.facilityName},{" "}
                <b>Ownership/Headquarters:</b>{" "}
                {props.facility.organizationName == ""
                  ? "N/A"
                  : props.facility.organizationName}
                , <b>Purchasing Group-Chain:</b>{" "}
                {props.facility.chain == ""
                  ? "N/A"
                  : props.facility.chain}
                ,
              </small>
            </span>
          </div>
        }
        dialogClassName="modal-90w"
        showButton={false}
        ref={(ref) => {
          woundAmendModal = ref;
        }}
      >
        <ViewWoundInformationChangeReason
          residentId={ResidentID}
          woundId={0}
        />
      </PopupModal>

      <PopupModal
        title="Add Wound Note"
        size="lg"
        showButton={true}
        ref={(ref) => {
          WoundNoteModal = ref;
        }}
      >
        <WoundNote />
      </PopupModal>

      <PopupModal
        title="Assignment of Benefits"
        dialogClassName="modal-90w"
        showButton={true}
        ref={(ref) => {
          AOBModal = ref;
        }}
      >
        <AOB />
      </PopupModal>

      <PopupModal
        title={
          <div className="card-title">
            <span>
              <h3 className="card-label">Resident Notes</h3>
              <small className="">
                <b>Resident:</b> {ResidentName},{" "}
                <b>Facility:</b> {facilityName},{" "}
                <b>Chain:</b> {chain},{" "}
                <b>Group:</b> {organizationName},{" "}
              </small>
            </span>
          </div>
        }
        dialogClassName="modal-90w"
        showButton={false}
        ref={(ref) => {
          ResidentNotesModal = ref;
        }}
      >
        <ResidentNotes FacilityId={FacilityId} ResidentID={ResidentID} />
      </PopupModal>

      <PopupModal
        title={
          <div className="card-title">
            <span>
              <h3 className="card-label">Add Resident</h3>
              <small className="">
                <b>Facility:</b> {props.facility.facilityName},{" "}
                <b>Ownership/Headquarters:</b>{" "}
                {props.facility.organizationName == ""
                  ? "N/A"
                  : props.facility.organizationName}
                , <b>Operators/Purchasing Group:</b>{" "}
                {props.facility.chain == ""
                  ? "N/A"
                  : props.facility.chain}
                ,
              </small>
            </span>
          </div>
        }
        dialogClassName="modal-97w"
        showButton={true}
        ref={(ref) => {
          AddResidentModal = ref;
        }}
        buttonDisabled={residentLoading}
        buttonPress={() => UpsertNewresident.handleSubmit()}
        module={ModulesName.Module_Residents}
        action={UserActions.Create}
        onClose={(ref) => {
          Common.showConfirmation(
            "Are you sure you want to close without saving the data?",
            "Warning",
            () => {
              ref.setState({ show: false });
            },
            () => {},
            null,
            "Exit Without Saving"
          );
        }}
      >
        <Newresident
          ref={(ref) => {
            UpsertNewresident = ref;
          }}
          FacilityId={FacilityId}
          Resident={Resident}
          handleNewWound={handleNewWound}
          user={user}
          facility={props.facility}
          setResidentLoading={setResidentLoading}
          close={() => {
            getAllResident();
            setResidentLoading(false);
            AddResidentModal.hideModal(true);
          }}
        />
      </PopupModal>

      <PopupModal
        title={
          <div className="card-title">
            <span>
              <h3 className="card-label">Resident Status</h3>
              <small className="">
                <b>Facility:</b> {props.facility.facilityName},{" "}
                <b>Ownership/Headquarters:</b>{" "}
                {props.facility.organizationName == ""
                  ? "N/A"
                  : props.facility.organizationName}
                , <b>Purchasing Group-Chain:</b>{" "}
                {props.facility.chain == ""
                  ? "N/A"
                  : props.facility.chain}
                ,
              </small>
            </span>
          </div>
        }
        ref={(ref) => {
          residentStatusModal = ref;
        }}
        showButton={true}
        buttonPress={() => addStatusRef.onSubmit()}
        module={ModulesName.Module_Residents}
        action={UserActions.Update}
      >
        <ResidentStatus 
          ref={(ref) => {
            addStatusRef = ref;
                  }}
          assessmentQueue={props.assessmentQueue}
          resident={Resident}
          close={() => {
            getAllResident();
            residentStatusModal.hideModal();
          }}
        />
      </PopupModal>

      <PopupModal
        title={
          <div className="card-title">
            <span>
              <h3 className="card-label">Resident History</h3>
              <small className="">
                <b>Facility:</b> {props.facility.facilityName},{" "}
                <b>Ownership/Headquarters:</b>{" "}
                {props.facility.organizationName == ""
                  ? "N/A"
                  : props.facility.organizationName}
                , <b>Purchasing Group-Chain:</b>{" "}
                {props.facility.chain == ""
                  ? "N/A"
                  : props.facility.chain}
                ,
              </small>
            </span>
          </div>
        }
        showButton={false}
        ref={(ref) => {
          residentHistoryModal = ref;
        }}
      >
        <FacilityResidentHistory fkResidentId={ResidentID} />
      </PopupModal>

      <PopupModal
        onClose={(ref) => {
          getAllResident();
          ref.setState({ show: false });
        }}
        title={
          <div className="card-title">
            <span>
              <h3 className="card-label">Wound Assessment </h3>
            </span>
          </div>
        }
        dialogClassName="modal-95w"
        ref={(ref) => {
          woundAssessmentModel = ref;
        }}
      >
        {showAddWoundComponent}
      </PopupModal>
    </>
  );
}

export default AllFacilityResident;
